var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrientationCource(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6045_3892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 12.1801C18.5996 12.1801 20.5676 10.7041 22.5236 10.2121C24.4796 9.72007 26.4476 10.2121 26.4476 10.2121V20.0281C26.4476 20.0281 24.4796 19.5361 22.5236 20.0281C20.5676 20.5201 18.5996 21.9961 18.5996 21.9961V12.1801Z",
    fill: "#E71D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4007 12.1801C17.4007 12.1801 15.4327 10.7041 13.4767 10.2121C11.5207 9.72007 9.55273 10.2121 9.55273 10.2121V20.0281C9.55273 20.0281 11.5207 19.5361 13.4767 20.0281C15.4327 20.5201 17.4007 21.9961 17.4007 21.9961V12.1801Z",
    fill: "#E71D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93555 26.004V6H32.0635V26.004",
    stroke: "black",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0716 29.9999H5.92764C3.71964 29.9999 1.93164 28.2119 1.93164 26.0039H34.0676C34.0676 28.2119 32.2796 29.9999 30.0716 29.9999Z",
    stroke: "black",
    strokeWidth: 2.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6045_3892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrientationCource);
export default __webpack_public_path__ + "static/media/orientation-cource.b941d5948b39d1288f5a600fa50507dc.svg";
export { ForwardRef as ReactComponent };